import { Tooltip } from "@material-ui/core";
import CryptoIcon from "components/Secondary/CryptoIcon";
import { format } from "date-fns";
import { formatNumber, formatPrice } from "helpers/helpers";
import { useEffect, useRef } from "react";
import "./recentTradeRow.scss";
import {ReactComponent as LinkArrow} from "assets/icons/linkArrow.svg";
import { useSelector } from "react-redux";

const RecentTradeRow = ({item, rowId}) => {
  const state = useSelector((state) => state.storage);
  const element = useRef();
  
  useEffect(() => {
    // eslint-disable-next-line
    let id;
    let currTime = new Date().getTime();
    if(currTime - item.lastReceived < 500) {
      !element.current?.classList.contains('flash') &&
      element.current?.classList.add('flash');
      id = setTimeout(
      () => {
        element.current?.classList.contains('flash') &&
        element.current?.classList.remove('flash');
        item.lastReceived = 0;
      },
      250,
    )
    }
  }, [item]);

  return <div className="recentTradeRow">
    <div ref={element} className="animateElement"/>
    <p className={item.side === "buy" ? "side buy" : "side sell"}>{item.side === "buy" ? "BUY" : "SELL"}</p>
    <p className="time">{format(item.blockUnixTime * 1000, "H:mm:ss")}</p>
    <p className="price">{item.tokenPrice > 0 ? "$" + formatPrice(item.tokenPrice,"auto") : "-"}</p>
    <p className="value">{item.volumeUSD > 0 ? "$" + formatPrice(item.volumeUSD,2) : "-"}</p>
    <div className="amount">
      <div className="token">
        <p className="symbol">{formatNumber(item.from.uiAmount,"auto")} {item.from.symbol}</p>  
      </div>
      <p className="arrow">-></p>
      <div className="token end">
        <p className="symbol">{formatNumber(item.to.uiAmount,"auto")} {item.to.symbol}</p>  
      </div>
    </div>
    <a className="by" href={"https://solscan.io/account/"+item.owner} target={"_blank"}>
      <p>{item.owner.slice(0,3)}···{item.owner.slice(-3)}</p>
    </a>
    <div className="source">
      <Tooltip title={"View Transaction on block explorer"}>
        <a href={"https://solscan.io/tx/"+item.txHash} target={"_blank"}>
          <LinkArrow stroke="var(--gray500)"/>
        </a>
      </Tooltip>
    </div>
  </div>
}

export default RecentTradeRow;